<!-- advertisement section -->
<div class="abt-section visiting-hours mt-80 mb-40" id="commodity-item">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="abt-bg">
          <img src="../assets/images/project/desiccatedcoconut.jpg" alt="im" />
          <!-- <a href="https://www.youtube.com/watch?v=DBLlFWYcIGQ" class="video-play-btn popup-youtube"><i class="lni lni-gallery"></i></a> -->
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <h1 class="display-6 text-white mt-5 mb-3">Desiccated Coconut</h1>
        <table class="table mb-100">
          <tbody>
            <tr>
              <td>Color</td>
              <td>White free from yellow</td>
            </tr>
            <tr>
              <td>Total Fat</td>
              <td
                ><ul>
                  <li>65% ± 2% (High Fat)</li>
                  <li>45% ± 5% (Low Fat)</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>pH</td>
              <td>6.1 – 6.7</td>
            </tr>
            <tr>
              <td>Size</td>
              <td>Fine / medium granule of coconut</td>
            </tr>
            <tr>
              <td>Moisture</td>
              <td>± 3 % max</td>
            </tr>
            <!-- <tr>
              <td>Free Fatty Acid (as lauric)</td>
              <td>0.1 % max</td>
            </tr> -->
            <!-- <tr>
              <td>Extraneous vegetable matter</td>
              <td>8 parts max per 100 gram</td>
            </tr> -->
            <!-- <tr>
              <td>Residual SO2</td>
              <td>50ppm max</td>
            </tr> -->
            <!-- <tr>
              <td>Packing</td>
              <td>Paper bags with inner Polyethylene (PE)</td>
            </tr> -->
            <tr>
              <td>Capacity</td>
              <td>90 MT/month</td>
            </tr>
            <tr>
              <td>Packing</td>
              <td>
                <ul>
                  <li>
                    Kraft Bag with Inner Food Grade Low Density Polyethylene, 25
                    kg/bag
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Max 40 feet HC Container</td>
              <td>± 25 – 26 MT</td>
            </tr>
            <tr>
              <td>Max 20 feet HC Container</td>
              <td>± 12 – 13 MT</td>
            </tr>
            <!-- <tr>
            <td>HS Code</td>
            <td>08011100</td>
          </tr> -->
            <tr>
              <td />
              <td />
            </tr>
            <!-- <tr>
            <td>Support</td>
            <td>
              <p class="mb-2">+012 345 6789</p>
              <p class="mb-0">support@example.com</p>
            </td>
          </tr> -->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- end advertisement section -->
<style>
  /* -----------------------------------------------------------------------------

# About Styles

----------------------------------------------------------------------------- */
  a.video-play-btn {
    position: absolute;
    background-color: #f28123;
    color: #051922;
    width: 70px;
    height: 70px;
    text-align: center;
    line-height: 80px;
    border-radius: 50%;
    font-size: 40px;
    padding-left: 5px;
    display: block;
    z-index: 2;
    top: 50%;
    margin-top: -45px;
    -webkit-box-shadow: 0 0 20px #adadad;
    box-shadow: 0 0 20px #adadad;
    left: 50%;
    margin-left: -45px;
  }

  .abt-bg {
    /* background-image: url(../assets/images/project/coconutsemihuskthree.jpg); */
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position: center;
    /* border-top-right-radius: 10px;
  border-bottom-left-radius: 10px; */
    position: relative;
    z-index: 1;
    overflow: hidden;
  }

  .abt-bg img {
    /* background-image: url(../assets/images/project/coconutsemihuskthree.jpg); */
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position: center;
    position: relative;
    overflow: hidden;
  }

  .abt-bg:after {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: "";
    background-color: #051922;
    opacity: 0.3;
  }

  .abt-section .abt-text {
    padding: 50px;
    padding-left: 30px;
  }

  .abt-text p {
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 10px;
  }

  .abt-text p.top-sub {
    opacity: 0.8;
    margin-bottom: 10px;
  }

  .abt-text p:last-child {
    margin-bottom: 0;
  }

  /*** Facts & Visiting Hours ***/
  .facts {
    background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
      url(../assets/zoo/img/bg-1.jpg) center center no-repeat;
    background-size: cover;
  }

  .visiting-hours {
    background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
      url(../assets/images/project/desiccatedcoconutlandscape.jpg) center center
        no-repeat;
    background-size: cover;
  }

  .visiting-hours .list-group-item {
    display: flex;
    justify-content: space-between;
    color: var(--light);
    background: rgba(0, 0, 0, 0.15);
    border-color: rgba(255, 255, 255, 0.15);
  }

  .visiting-hours .table {
    color: var(--light);
    background: rgba(0, 0, 25, 0.15);
  }

  .visiting-hours .table td {
    padding: 0.5rem 1rem;
    border-color: rgba(0, 0, 0, 0.15);
    border-width: 1px;
  }

  .visiting-hours .table tr:last-child td {
    border: none;
  }
</style>
